import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData({
        url: 'https://wh11.wenhua.com.cn/',
    }).then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0

        //网站title定制
        if(!document.title){
            let obj = {};
            res.forEach(item => {
                obj[item.keyname] = item.value;
            });
            document.title = obj['appShortName_37'] + obj['appFullName_37'];
        }
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()